import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./installMethodDropdown.html";
// Feature-local native select for the dense listing install card. This is intentionally not a
// WDS primitive: its styling, labels, and analytics all belong to the install-card experience.
class InstallMethodDropdown extends LightningElement {
  constructor(...args) {
    super(...args);
    this.options = [];
    this.selectedId = '';
    this.ariaLabel = null;
  }
  get optionsWithSelection() {
    return this.options.map(opt => ({
      ...opt,
      selected: opt.id === this.selectedId
    }));
  }
  handleChange(event) {
    const target = event.target;
    this.dispatchEvent(new CustomEvent('change', {
      detail: {
        selectedId: target.value
      },
      bubbles: true
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(InstallMethodDropdown, {
  publicProps: {
    options: {
      config: 0
    },
    selectedId: {
      config: 0
    },
    ariaLabel: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(InstallMethodDropdown, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;